var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCariconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.005,
    height: 14,
    viewBox: "0 0 18.005 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_2",
    "data-name": "Subtra\\xE7\\xE3o 2",
    d: "M16.574,14H15.325a.971.971,0,0,1-.957-.982v-1.17H3.62v1.17A.971.971,0,0,1,2.663,14H1.413a.971.971,0,0,1-.956-.982V8.333A7.539,7.539,0,0,1,.907,5.99l.152-.38h-.1A.971.971,0,0,1,0,4.628v-.55a.747.747,0,0,1,.741-.8.88.88,0,0,1,.239.034l.9.254.942-2.355A2.058,2.058,0,0,1,4.58,0h8.828a2.058,2.058,0,0,1,1.761,1.212l.943,2.358.909-.257a.906.906,0,0,1,.239-.034.747.747,0,0,1,.741.8v.55a.971.971,0,0,1-.956.982h-.116l.152.381a7.532,7.532,0,0,1,.45,2.342v4.685a.971.971,0,0,1-.957.981ZM14.735,7.3a1.421,1.421,0,1,0,1.384,1.421A1.4,1.4,0,0,0,14.735,7.3ZM3.483,7.03a1.421,1.421,0,0,0,0,2.841,1.421,1.421,0,0,0,0-2.841ZM5.135,1.648a1.234,1.234,0,0,0-1.056.726l-1.07,2.7a.545.545,0,0,0,.023.518.521.521,0,0,0,.452.208h11.2a.521.521,0,0,0,.451-.207.547.547,0,0,0,.023-.519L14,2.374a1.235,1.235,0,0,0-1.056-.726Z",
    transform: "translate(0.002)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCariconBlack);
export default __webpack_public_path__ + "static/media/caricon_black.4cf9ef2d.svg";
export { ForwardRef as ReactComponent };